import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Breadcrumb,
  BackdropCircular,
  ImageGalleryDialog
} from 'components';
import {
  Card,
  Typography,
  Divider,
  Grid,
  Button,
  Icon,
  Switch
} from '@material-ui/core';
import {
  getAppointmentBlockConfigsApi,
  saveAppointmentBlockConfigsApi,
  getAssetManagerCategoryTagsApi
} from 'api';
import {
  changeAppointmentBlockConfig
} from 'redux/actions/store_configs';
import { assetManagerUrl } from 'configs';
import AppointmentFormBlockPreview from './AppointmentFormBlockPreview';


const AppointmentFormBlock = () => {
  const dispatch = useDispatch();
  const [openImageDialog, toggleOpenImageDialog] = useState(false);
  const {
    appointmentBlockConfigs = [],
    loadingAppointmentBlockConfigs,
    savingAppointmentBlockConfigs
  } = useSelector((state) => state.store_configs);

  const {
    assetCategoryTags,
    loadingAssetCategoryTags
  } = useSelector((state) => state.asset_manager);
  const loading = loadingAppointmentBlockConfigs ||
    savingAppointmentBlockConfigs ||
    loadingAssetCategoryTags;

  useEffect(() => {
    if (!appointmentBlockConfigs.length) {
      getAppointmentBlockConfigsApi({dispatch});
    }

    if (!assetCategoryTags.length) {
      getAssetManagerCategoryTagsApi({dispatch, categoryName: 'Storebuild-automaton'});
    }
  });

  const imageSrc = appointmentBlockConfigs?.find((config) => config.path === 'dermpro/design/appointment_block_mobile')?.value;
  const tagId = assetCategoryTags.find((tag) => tag.label === 'Appointment block (mobile)')?.id;
  const isBlockEnabled = appointmentBlockConfigs?.find((config) => config.path === 'store_info/request_an_appointment/is_request_an_appointment_enabled')?.value;

  const handleChangeIsBlockEnabled = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeAppointmentBlockConfig(name, checked, type, value));
  };

  const handleSelectImage = (data) => {
    const value = `${assetManagerUrl}/${encodeURIComponent(data?.webPath)}`;
    dispatch(changeAppointmentBlockConfig(
      'dermpro/design/appointment_block_mobile',
      null,
      'text',
      value
    ));
  };

  const handleSave = () => {
    saveAppointmentBlockConfigsApi({dispatch, configs: appointmentBlockConfigs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'Configurations', path: '/settings#configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: 'Appointment Form Block'}
        ]}
      />
      <div className="m-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-8">Appointment Form Block</Typography>
          <Divider className="mb-8" />
          <Grid container spacing={3} className="mb-8">
            <Grid item xs={12} sm={2} className="ml-4">Enabled</Grid>
            <Grid item xs={12} sm={9}>
              <Switch
                color="primary"
                name={'store_info/request_an_appointment/is_request_an_appointment_enabled'}
                checked={isBlockEnabled == 1}
                onChange={handleChangeIsBlockEnabled}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} className="mb-8">
            <Grid item xs={12} sm={2} className="ml-4">Image</Grid>
            <Grid item xs={12} sm={9}>
              <Button
                className="w-full max-w-300"
                variant="outlined"
                color="primary"
                size="large"
                onClick={() => toggleOpenImageDialog(true)}
              >
                <Icon className="mr-2">wallpaper</Icon>
                Select Image
              </Button>
            </Grid>
          </Grid>
        </Card>
        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="mt-10 mb-5"
            onClick={handleSave}
          >
            Save Configurations
          </Button>
        </div>
        <AppointmentFormBlockPreview
          imageSrc={imageSrc}
        />
      </div>
      <ImageGalleryDialog
        title="Select Appointment Form Block Image"
        open={openImageDialog}
        setOpen={toggleOpenImageDialog}
        onImageSelect={handleSelectImage}
        imageTagId={tagId}
        cols={4}
        rowHeight={340}
      />
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default AppointmentFormBlock;
